import PuzzleRemoteListAbstract from './PuzzleRemoteListAbstract';
import withVirtualScroll from '../../../dispatcher/hoc/withVirtualScroll';

class PuzzleRemoteMenu extends PuzzleRemoteListAbstract {}

export default withVirtualScroll(PuzzleRemoteMenu);
